import React from "react";
import { Badge, ThemeIcon, Tooltip } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import type { ReleaseNote } from "./releaseNotesData";
import { offersWindowsDownload } from "./releaseCatalog";

export default function ReleaseBadges({
  release,
  current,
  downloadHint = false,
}: {
  release: ReleaseNote;
  current?: ReleaseNote;
  downloadHint?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <>
      {release.notesPending ? (
        <Badge variant="light">{t("releaseNotes.notesComingSoon")}</Badge>
      ) : null}
      {release.version === current?.version ? (
        <Badge color="orange" radius="sm">
          {t("releaseNotes.desktopLatest")}
        </Badge>
      ) : null}
      {downloadHint && offersWindowsDownload(release, current) ? (
        <Tooltip label={t("releaseNotes.downloadAvailable")} withArrow>
          <ThemeIcon
            variant="light"
            color="orange"
            radius="xl"
            size={22}
            role="img"
            aria-label={t("releaseNotes.downloadAvailable")}
          >
            <IconDownload size={13} />
          </ThemeIcon>
        </Tooltip>
      ) : null}
      {release.label ? (
        <Badge color="orange" radius="sm">
          {release.label}
        </Badge>
      ) : null}
    </>
  );
}
